import React, { useMemo } from 'react';

import { Category, CategoryList, ExpandedCategories, SharedGA4args } from '@browsing/filters';
import { TranslateScope } from '@pegasus/translation';
import { getGA4Context } from '@browsing/tracking';

import { findCategoryById, redirectToCrossCampaignCatalogMultiCategorySelect } from '../utils';

interface Props {
    allCategories: Category;
    selectableCategories?: Category;
    isRootCategoryToggleDisabled?: boolean;
    setSelectedCategory: (category: Category | null) => void;
    selectedCategories: Category[];
    resetSelectedCategories: () => void;
    handleSelectedCategories: (categoryIds: number[]) => void;
    preExpandedCategories: ExpandedCategories;
    resetPreExpandedCategories: () => void;
}

export const CrossCampaignCategoryList = ({
    allCategories,
    selectableCategories = allCategories,
    isRootCategoryToggleDisabled = false,
    selectedCategories,
    resetSelectedCategories,
    handleSelectedCategories,
    preExpandedCategories,
    resetPreExpandedCategories,
    setSelectedCategory,
}: Props) => {
    const setVisibilityFilterMultiCategorySelect = (
        _: string,
        isWithoutHashMeta: boolean,
        shouldSave?: boolean,
    ) => {
        if (!shouldSave) {
            resetPreExpandedCategories();
            resetSelectedCategories();
            return;
        }

        if (!selectedCategories.length) {
            return;
        }

        redirectToCrossCampaignCatalogMultiCategorySelect(selectedCategories.map(({ id }) => id));
    };

    const updateFilter = (filter: { categories: number[] }) => {
        const categoryId = filter.categories[0];
        const foundCategory = findCategoryById({
            category: allCategories,
            id: categoryId,
        });
        setSelectedCategory(foundCategory);
    };

    const isCategorySelected: boolean = !!preExpandedCategories.level1;

    const selectedCategoriesIds = selectedCategories.map(({ id }) => id);

    const sumTotalArticleCount = () => {
        if (selectedCategories.length) {
            return selectedCategories.reduce((acc, { count }) => acc + count, 0);
        }

        return 0;
    };

    const totalArticleCount = sumTotalArticleCount();
    const sharedGA4args = useMemo(
        (): SharedGA4args => ({ context: getGA4Context({ isCrossCampaign: true }) }),
        [],
    );

    return (
        <TranslateScope path="catalog">
            {isCategorySelected && (
                <CategoryList
                    allCategories={selectableCategories}
                    availableCategories={selectableCategories}
                    selectedCategories={selectedCategoriesIds}
                    campaign={null}
                    setVisibilityFilter={setVisibilityFilterMultiCategorySelect}
                    showCategoriesModal={true}
                    updateFilter={updateFilter}
                    totalArticlesCount={totalArticleCount}
                    isResetHidden={true}
                    isRootCategoryToggleDisabled={isRootCategoryToggleDisabled}
                    isCrossCampaign={true}
                    isMyLoungeCrossCampaignEntry={true}
                    updateCategoriesFilter={handleSelectedCategories}
                    preExpandedCategories={preExpandedCategories}
                    sharedGA4args={sharedGA4args}
                />
            )}
        </TranslateScope>
    );
};
